import { Toast } from '../classes/AppToast';

import { gtag, install } from 'ga-gtag';
import * as bootstrap from 'bootstrap';


install('G-Z1TCCW3ELM', { 'send_page_view': false });

window.addEventListener('online', () => {
    let offlineToast = document.querySelector('.toast-offline');
    if (offlineToast) {
        offlineToast.remove();
    }

    document.body.classList.remove('app-offline');
    document.body.classList.add('app-online');

    if (window.App && window.App.initialized) {
        window.App.load('trip', { _reload: true });
    }
});

window.addEventListener('offline', () => {
    document.body.classList.remove('app-online');
    document.body.classList.add('app-offline');

    Toast.show(
        'No estás conectado a internet. Algunas acciones pueden estar desactivadas.',
        'danger',
        true,
        false,
        'toast-offline'
    );
});
if (!navigator.onLine) {
    document.body.classList.add('app-offline');
}


window.addEventListener('beforeinstallprompt', (event) => {
    event.userChoice.then((response) => {
        gtag('event', 'add_to_home', {
            value: response.outcome
        });
    });
});

document.addEventListener('App:Rendered', async (e) => {
	const splashEvent = new CustomEvent('App:Splashed');
    if (!document.body.dataset.appInitialized) {
        document.body.dataset.appInitialized = 'true';
        setTimeout(() => {
            const splash = document.querySelector('.app-splash');
            splash.classList.add('animate__fadeOut');
            splash.addEventListener('animationend', (e) => { e.target.remove(); });

			document.dispatchEvent(splashEvent);
        }, 1200);
    } else {
		document.dispatchEvent(splashEvent);
	}

    let followLinks = document.querySelectorAll('.follow-link');
    if (followLinks) {
        followLinks.forEach((link) => {
            link.addEventListener('click', function (e) {
                e.preventDefault();
                window.open(this.href, '_blank', 'location=no');
            });
        })
    }

    if (await window.App.auth.isAuthenticated()) {
        const supportBtn = document.querySelector('.open-support');        
        if (supportBtn) {
            let phone = '5491159540923';
            const trip = await window.App.db.getTrip();
            if (trip.application.subprogram_id === 1) phone = '5491123913856';
            supportBtn.addEventListener('click', function (e) {
                e.preventDefault();
                window.open('whatsapp://send?phone=' + phone, '_system', 'hidden=yes');
            });
        }
    }

    const dropdownElementList = document.querySelectorAll('[data-bs-toggle="dropdown"]');
    const dropdownList = [...dropdownElementList].map(dropdownToggleEl => new bootstrap.Dropdown(dropdownToggleEl));

    const collapseElementList = document.querySelectorAll('.collapse')
    const collapseList = [...collapseElementList].map(collapseEl => new bootstrap.Collapse(collapseEl, { toggle: false }));


    const copyElements = document.querySelectorAll('.copy-clipboard');
    copyElements.forEach((element) => {
        element.addEventListener('click', async function (e) {
            e.preventDefault();
            const text = this.dataset.text || this.textContent || this.innerText;

            if (!text || !text.trim()) {
                return;
            }

            try {
                await navigator.clipboard.writeText(text.trim());
                Toast.show('Copiado', 'success');
            } catch (error) {
                Toast.show('Error al Copiar', 'danger');
            }
        });
    });
});

export var videoTutorialOptions = {
    height: 300,
    playerVars: {
        enablejsapi: 1,
        controls: 1,
        modestbranding: 1,
        rel: 0,
        origin: "https://app.wetag.ar",
        showinfo: 0,
    }
};